<template>
	<router-link :to="to" class="app-route" active-class="app-route-active">
		<transition name="slide-fade">
			<div v-if="isActive" class="app-route-marker" />
		</transition>
		<app-icon v-if="icon" class="app-route-icon" :icon="icon" />
		<span class="app-route-title font-semibold">{{ $t(name) }}</span>
	</router-link>
</template>

<script>
	import AppIcon from '../../app/AppIcon';

	export default {
		name: 'SidebarItem',
		components: {
			AppIcon,
		},
		props: ['to', 'icon', 'name'],
		computed: {
			isActive() {
				return this.to.name === this.$route.name;
			},
		},
	};
</script>
